import script from "./WidgetList.vue?vue&type=script&setup=true&lang=ts"
export * from "./WidgetList.vue?vue&type=script&setup=true&lang=ts"

import "./WidgetList.vue?vue&type=style&index=0&id=16dc387c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16dc387c"]])